<template>
    <div>
        <b-row>
            <b-col cols="6">
                <b-form-group :label="$t('member')">
                    <b-input-group>
                        <div class="label-as-input">{{ form.student_number+' '+form.name+' '+form.surname }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group :label="$t('status')">
                    <b-input-group>
                        <div class="label-as-input">{{ statusText  }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    //Service
    import StudentClubService from '@/services/StudentClubService';

    export default {
        props: {
            formId: {
                type: Number
            }
        },
        data() {
            return {
                form: {
                },
                statusText: null
            }
        },
        created() {
            this.get(this.formId)
        },
        methods: {
            get(id) {
                this.formLoading = true;
                StudentClubService.getPresidentUsers(id)
                                .then((response) => {
                                    this.form = response.data.data;
                                    this.statusText = this.statusTextSet(this.form.status)
                                    this.formLoading = false;
                                })
                                .catch((error) => {
                                    this.showErrors(error)
                                });
            },

            statusTextSet(status) {
                if (status === 'approved') {
                    return this.$t('approved');
                } else if (status === 'waiting') {
                    return this.$t('waiting');
                } else if (status === 'declined') {
                    return this.$t('declined');
                } else {
                    return '';
                }
            }
        }
    }
</script>
